export default [
  {
    _name: "CSidebarNavTitle",
    _children: ["Công cụ khác"],
    permission: 'tools'
  },

  {
    _name: "CSidebarNavItem",
    name: "Bản đồ",
    to: "/map/land",
    icon: "cil-layers",
    permission: 'tool_map'
  },

  // {
  //   _name: 'CSidebarNavItem',
  //   name: 'Mã tên đường',
  //   to: '/others/street_code',
  //   icon: 'cil-layers'
  // },

  // {
  //   _name: "CSidebarNavItem",
  //   name: "Tài chính",
  //   to: "/others/finance",
  //   icon: "cil-layers",
  //   permission: 'tool_finance'
  // },

  {
    _name: "CSidebarNavItem",
    name: "Định giá",
    to: "/v2/validation",
    icon: "cil-layers",
    permission: 'tool_valuation'
  },
];
